import React, { useCallback, useState } from "react";
import {
  mini_color_card_wrapper,
  info,
  color_box,
  copy_overlay,
} from "../../styles/modules/mini_color_card.module.css";

function MinColorCard({ color, onCopy }) {
  const [copied, setCopied] = useState(false);
  const colorHex = color?.toUpperCase() || "#000000";

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(colorHex);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
    if (onCopy) onCopy(colorHex);
  }, [colorHex, onCopy]);

  return (
    <div
      className={mini_color_card_wrapper}
      onClick={handleCopy}
      title={`Copiar ${colorHex}`}
    >
      <div className={color_box} style={{ backgroundColor: colorHex }}>
        <div className={copy_overlay}>
          {copied ? (
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ) : (
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
          )}
        </div>
      </div>
      <div className={info}>{colorHex}</div>
    </div>
  );
}

export default MinColorCard;
